module.exports = __webpack_public_path__ + "img/uy.a15df864.svg";